import { Timeline as AntTimeline } from 'antd';
import AntTimelineItem from 'antd/lib/timeline/TimelineItem';
import styled from 'styled-components';

import { parseIconType } from '../../utils/normalizers/parseIconByNotificationType';

const RealTimelineWrapper = styled.div`
  overflow-y: scroll;
  background-color: unset;
  max-height: 62vh;
  margin-right: ${(props: WrapperProps) => props.mr};
  padding: ${(props: WrapperProps) => props.padding};
  max-width: 500px;

  @media (min-width: 1280px) {
    width: ${(props: WrapperProps) => props.width};
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 50px rgba(45, 125, 200, 1);
    box-shadow: inset 0 0 50px rgba(45, 125, 200, 1);
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 20px rgba(0, 0, 0, 0);
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0);
    border-radius: 5px;
  }
`;

export interface Item {
  type: 'success' | 'warning' | 'error' | 'false' | string;
  message: string;
  date: string;
}

interface Props {
  items: Item[];
  className?: string;
  pending?: string;
  width?: string;
  padding?: string;
  mr?: string;
}

interface WrapperProps {
  className?: string;
  width?: string;
  padding?: string;
  mr?: string;
}

const Timeline: any = AntTimeline;

const TimelineItem: any = AntTimelineItem;

const RealTimeline = ({ items, className, pending, width = '500px', padding = '10px 20px 20px 0' }: Props) => {
  return (
    <RealTimelineWrapper className={className} width={width} padding={padding}>
      <Timeline reverse={false} pending={pending}>
        {items.map(({ type, date, message }: Item, index) => (
          <TimelineItem key={index} dot={parseIconType(type, 10)}>
            {date} - {message}
          </TimelineItem>
        ))}
      </Timeline>
    </RealTimelineWrapper>
  );
};

export default RealTimeline;
